{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/home-link",
	"category": "design",
	"parent": [ "core/navigation" ],
	"title": "Home Link",
	"description": "Create a link that always points to the homepage of the site. Usually not necessary if there is already a site title link present in the header.",
	"textdomain": "default",
	"attributes": {
		"label": {
			"type": "string",
			"role": "content"
		},
		"opensInNewTab": {
			"type": "boolean",
			"default": false
		},
		"description": {
			"type": "string"
		}
	},
	"usesContext": [
		"textColor",
		"customTextColor",
		"backgroundColor",
		"customBackgroundColor",
		"fontSize",
		"customFontSize",
		"style"
	],
	"supports": {
		"anchor": true,
		"reusable": false,
		"html": false,
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalLetterSpacing": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		},
		"interactivity": {
			"clientNavigation": true
		}
	},
	"editorStyle": "wp-block-home-link-editor",
	"style": "wp-block-home-link"
}
